<template>
  <div class="double-icon" :style="iconSize" @click="$emit('click')">
    <font-awesome-icon class="double-icon__outer"
                       :icon="outerIcon"
                       :style="iconSize"/>
    <font-awesome-icon class="double-icon__inner"
                       :icon="innerIcon"
                       :style="innerIconStyle" />
  </div>
</template>

<script>
export default {
  name: 'NextDoubleIcon',
  props: {
    outerIcon: {
      type: Array,
      required: true,
    },
    innerIcon: {
      type: Array,
      required: true,
    },
    center: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    iconSize() {
      if (this.size) {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
        };
      }
      return {};
    },
    innerIconStyle() {
      if (this.size) {
        return {
          position: 'absolute',
          top: `${this.size / 8}px`,
          left: `${this.size / 4}px`,
          width: `${this.size / 2}px`,
          height: `${this.size / 2}px`,
        };
      }
      return {};
    },
  },
};
</script>

<style scoped lang="scss">

  .double-icon{
    position: relative;
    width: 32px;
    height: 32px;
    &__outer{
      width: 32px;
      height: 32px;
      top: 0;
      left: 0;
      position: absolute;
    }
    &__inner{
      width: 16px;
      height: 16px;
      left: 8px;
      top: 4px;
      position: absolute;
      &--center{
        top: 8px;
      }
    }
  }
</style>
